{
    "wishlist": {
        "empty": "Aktuell sind keine Produkte in Ihrem Merkzettel enthalten."
    }
}